import React from "react";
import Deneme from "../Deneme/Deneme";

const EgitimAnaCard = () => {
  return (
    <div>
      <div className="grid-cols-1 sm:grid md:grid-cols-3 ml-10 mr-10 md:ml-20 md:mr-20 mb-16">
        <div className="mx-3 mt-6 flex flex-col rounded-lg bg-gray-300 text-surface shadow-secondary-1 dark:bg-surface-dark sm:shrink-0 sm:grow sm:basis-0">
          <a href="#!">
            <img
              className="rounded-t-lg"
              src="https://st2.depositphotos.com/3591429/10464/i/450/depositphotos_104648666-stock-photo-group-of-people-brainstorming-on.jpg"
              alt="Hollywood Sign on The Hill"
            />
          </a>
          <div className="p-6">
            <h5 className="text-xl font-bold mb-2">HAKKIMIZDA</h5>
            <p className="mb-4 text-base">
              Jojo Eğitim yurtiçi ve yurtdışı öğrenci organizasyonları ve eğitim
              programları üzerinde uzmanlaşmış bir kuruluştur...
            </p>
            <Deneme
              imgUrl="https://st2.depositphotos.com/3591429/10464/i/450/depositphotos_104648666-stock-photo-group-of-people-brainstorming-on.jpg"
              title="HAKKIMIZDA"
              desc="Jojo Eğitim, yurtdışı öğrenci organizasyonları ve eğitim programları üzerinde uzmanlaşmış bir kuruluştur. Organizasyonun her aşamasında uzman kadrosu ve uluslararası alanda uzun yıllar hizmet veren konusunda branşlaşmış partnerleriyle birlikte güvenilir, kaliteli ve deneyimli bir hizmet sunar.

              Dinamik kadrosu ile 10 yıllık bir tecrübeye sahip olan Jojo Eğitim, 180 aşkın okulda hizmet sunarken, programlarına 25000'den fazla öğrenci katılımı sağlamıştır. Hizmet vermekte olduğu okulların portföyü ile her yıl 50000'den fazla öğrenciye temas etmektedir. Edindiği bu tecrübe ve çalışma ağı sayesinde, kaliteden ödün vermeden, programlarını en uygun fiyata sunmaktadır.  Ve bu bağlamda alanında öncü olmaya devam etmektedir.
      
              Jojo Eğitim, profesyonel ve kurumsal yaklaşım ile kaliteli, hizmet ağırlıklı ve müşteri memnuniyeti odaklı “Uluslararası Öğrenci Programları” modelini benimsemektedir. Bu kapsamda en çok tercih edilen yurtiçi ve yurtdışı eğitim programlarını Türkiye'de gerçekleştirmeye devam etmektedir.
      
               Dünya'nın farklı lokasyonlarında gerçekleşen eğitim programlarını da takip eden Jojo Eğitim, Türkiye'de ilkleri sunan firma olma hevesini de
      
      her yıl korumaktadır..."
            />
          </div>
        </div>
        <div className="mx-3 mt-6 flex flex-col rounded-lg bg-gray-300 text-surface shadow-secondary-1 dark:bg-surface-dark sm:shrink-0 sm:grow sm:basis-0">
          <a href="#!">
            <img
              className="rounded-t-lg"
              src="https://images.pexels.com/photos/5428829/pexels-photo-5428829.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
              alt="Hollywood Sign on The Hill"
            />
          </a>
          <div className="p-6">
            <h5 className="text-xl font-bold mb-2">NEDEN JOJO EĞİTİM ?</h5>
            <p className="mb-4 text-base">
              Jojo Eğitim sadece eğitim programları üzerinde uzmanlaşmış bir
              kuruluştur. Organizasyonun her aşamasında, uluslararası alanda
              uzun yıllardır hizmet veren...
            </p>
            <Deneme
              imgUrl="https://images.pexels.com/photos/5428829/pexels-photo-5428829.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
              title="NEDEN JOJO EĞİTİM ?"
              desc="Jojo Eğitim sadece öğrenci programları üzerinde uzmanlaşmış bir kuruluştur.

              Organizasyonun her aşamasında, uluslararası alanda uzun yıllardır hizmet veren, konusunda branşlaşmış partnerleri ile birlikte güvenilir, kaliteli ve deneyimli bir hizmet sunar.
              
                    Eğitim organizasyonlarına katılım imkanı sunar.
              
                    Sınırlı kontenjan ve ön kayıt koşullu bilim ve eğitim organizasyonlarına katılım imkanı sunar.
              
              Uzman kadrosuyla birlikte 10 yılı aşkın bir süredir bu hizmeti vermektedir.
              
              7/24 proaktif destek sunar. 
              
              Eğitim organizasyonlarındaki tecrübesi ve sahip olduğu portföyle, programları en uygun fiyata mal eder.
              
              Tecrübesiyle öğretmene, veliye ve öğrenciye program öncesi gerekli eğitim ve bilgilendirmeyi yapar.
              
              Türkiye'de ilk defa gerçekleştirilen programlara sahiptir.
              
              Okulların talepleri doğrultusunda programlarını esnetebilir, özelleştirebilir.
              
              Organizasyonlarında süreç ve veli bilgilendirme Jojo Eğitim tarafından yürütülür. okullara ek yük getirmez."
            />
          </div>
        </div>
        <div className="mx-3 mt-6 flex flex-col rounded-lg bg-gray-300 text-surface shadow-secondary-1 dark:bg-surface-dark sm:shrink-0 sm:grow sm:basis-0">
          <a href="#!">
            <img
              className="rounded-t-lg"
              src="https://images.pexels.com/photos/1148998/pexels-photo-1148998.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
              alt="Hollywood Sign on The Hill"
            />
          </a>
          <div className="p-6">
            <h5 className="text-xl font-bold mb-2">PROGRAMLARIN AMACI</h5>
            <p className="mb-4 text-base">
              Öğrencilerimiz katılacakları eğitsel programlardan edinecekleri
              bilgilerin dışında kültürel bilgeliğin yanında sosyal yetilerini
              de geliştireceklerdir.
            </p>
            <Deneme
              imgUrl="https://images.pexels.com/photos/1148998/pexels-photo-1148998.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
              title="PROGRAMLARIN AMACI"
              desc="Jojo Eğitim öğrenci programlarında, öğrencilerimiz katılacakları eğitsel programlardan edinecekleri bilgilerin dışında kültürel bilgeliğin yanı sıra sosyal yetilerini de geliştireceklerdir.

              Teoride kazandıkları bilgileri gözlemleyebilecek, uygulama fırsatı bulabilecekler. 
           
               Kariyer hedeflerini netleştirerek henüz daha bu yolun başındayken belirleyebilecekler."
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default EgitimAnaCard;
